import { render, staticRenderFns } from "./RateComponent.vue?vue&type=template&id=669d9ea8&functional=true&"
import script from "./RateComponent.vue?vue&type=script&lang=js&"
export * from "./RateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports